<template lang="pug">
section
  s-page-title(
    :previous='true',
    :subtitle='section.section_name',
    :title='floorId ? "Редактирование этажа" : "Добавление этажа"'
  )
  v-card
    v-container(grid-list-xl, fluid)
      v-layout(wrap)
        v-flex(xs12)
          .subheading.font-weight-medium Выберите этажи
          .mt-3.pt-3.pl-3.pr-3.floors-picker
            v-checkbox.floor-checker-btn.mb-0.mt-1.mr-4(
              v-for='floor in floors',
              :key='floor',
              :value='floor',
              :label='floor.toString()',
              :error='errors.has("floor_numbers")',
              :error-messages='errors.first("floor_numbers")',
              :disabled='isFloorDisabled(floor)',
              v-model='selectedFloors',
              color='success'
            )
        v-flex(xs12)
          v-card-actions
          v-spacer
          v-btn(
            :loading='isLoading || isSectionsLoading',
            @click.native='copyFloorInSetcion',
            color='primary',
            depressed,
            small
          ) Копия с этажа в подъезде
          v-btn(
            :loading='isLoading || isSectionsLoading',
            @click.native='copyFloorFromAllSetcion',
            color='light',
            depressed,
            small
          ) +
          v-btn(
            :loading='isLoading || isSectionsLoading',
            @click.native='exctractFloors',
            color='light',
            depressed,
            small
          ) Выделить этажи


  v-card
    v-container(grid-list-xl, fluid)
      v-layout(wrap)
        v-flex(xs12)
          v-tabs(v-model='tabs.active', color='dark', slider-color='primary')
            v-tab(v-for='tab in tabs.getByObjectType(object)', :key='tab.name')
              | {{ tab.name }}
        v-flex(xs12 class="layout-view")
          div(class="col-a")
            div(class="sticky-pane")
              s-image-upload(
                :src='item.floor_scheme_url',
                :editor='true',
                :scheme='true',
                @editor='editorOpened = true',
                @remove='onRemoveScheme',
                v-model='item.floor_scheme',
                label='План этажа',
                :has-preview='Boolean(item.floor_scheme_url)'
              )
                floor-scheme-preview(
                  :placements='placementsByType',
                  :scheme='item.floor_scheme_url',
                  :view-box='item.floor_viewbox',
                  slot='extension'
                )
          div(class="col-b")
            v-layout(wrap)
              v-flex(xs12, sm3)
                v-text-field(
                  :error='errors.has("placements_count")',
                  :error-messages='errors.first("placements_count")',
                  :hint='`Макс. кол-во на этаже ${maxPlacements}`',
                  v-model.number='countByType',
                  label='Кол-во на этаже',
                  persistent-hint,
                  mask='###'
                )
              v-flex(xs12, sm3)
                v-text-field(
                  :error='errors.has("placements_count")',
                  :error-messages='errors.first("placements_count")',
                  v-model.number='item.placements_count',
                  label='Общее кол-во на этаже',
                  persistent-hint,
                  disabled,
                  mask='###',
                  :hint='`Макс. кол-во на этаже ${maxPlacements}`'
                )
              v-flex(v-if='placementsByType.length > 0', xs12, sm6)
                div(class="d-flex")
                  v-btn(
                    :loading='isLoading || isSectionsLoading',
                    @click.native='matchLayouts',
                    color='light',
                    depressed,
                    small,
                  ) Автоподбор планировок
              v-flex(xs12)
                br
                v-divider
              v-flex(v-if='placementsByType.length > 0', xs12)
                v-data-table.placements-list(
                  :expand='expand',
                  :headers='headers',
                  :items='placementsByType',
                  hide-actions,
                  dense
                )
                  template(slot='items', slot-scope='props')
                    tr(@click='props.expanded = !props.expanded')
                      td(class="text-xs-center") {{ props.index + 1 }}
                      td(class="text-xs-center")
                        span(class="highlight") {{ props.item.placement_number }}
                      td
                        s-layout-picker(
                          v-model='props.item.layout_id',
                          :objectId='objectId'
                        )
                      td
                        div(v-if="hasPreview(props.item)")
                          v-tooltip(left, open-delay=0, close-delay=0, content-class="hover-tooltip")
                            span(
                              class='preview-trigger',
                              @mouseenter='openPreview(props.item)',
                              @mouseleave='closePreview()',
                              slot='activator'
                            )
                              v-img(
                                :src='getFirstNeedlePreviewImage(props.item)',
                                :lazy-src='getFirstNeedlePreviewImage(props.item)',
                                class='grey lighten-4 thumb sm-avatar'
                              )
                                v-layout(slot='placeholder' fill-height align-center justify-center ma-0)
                                  v-progress-circular(indeterminate color='primary' :size='24')
                            div(v-if="preview", class="hover-preview")
                              img(:src="preview")
                      td.text-xs-center
                        v-icon(v-if='props.item.points', color='primary', small) check
                      td(class='text-xs-center' @click.stop)
                        div(class="d-inline-block")
                          v-checkbox(
                            v-model='props.item.has_next_level'
                            class='inline-checkbox'
                            color='success'
                          )
                      td.text-xs-right
                        v-btn(@click='onEditorRemove(props.item)', small, icon)
                          v-icon(small) delete_outline
                  template(slot='expand', slot-scope='props')
                    v-text-field.placement_path(
                      :value='props.item.points',
                      @change='updatePlacementPoints($event, props.index)',
                      label='Обводка',
                      dense,
                      clearable
                    )
    v-card-actions.large
      v-spacer
      s-back-btn
      v-btn(
        :loading='isLoading || isSectionsLoading',
        @click.native='onSave',
        color='primary',
        depressed
      ) Сохранить
  modal-editor(
    v-model='editorOpened',
    :placements='placementsByType',
    :source='item.floor_scheme_url',
    :file-view-box='item.floor_viewbox',
    @update='onEditorUpdate',
    @create='onEditorCreate',
    @remove='onEditorRemove'
  )
    template(slot='list')
      s-placements-list(
        :placements='placementsByType',
        @sort='onChangePlacementsSort'
      )
  copy-struct-dialog(
    :floorId="floorId"
    v-if='copyDialogIsOpen'
    :isOpen='copyDialogIsOpen'
    :inSection = 'currentSectionForCopy'
    @undo='copyDialogIsOpen=false'
    @copySuccess='applyPlacementStructCopy'
  )
  Extract-floors-dialog(
    :floorId="floorId"
    v-if='ExtractFloorsDialogIsOpen'
    :isOpen='ExtractFloorsDialogIsOpen'
    :inSection = 'currentSectionForCopy'
    @undo='ExtractFloorsDialogIsOpen=false'
    @extractSuccess='goToNewFloor'
  )
</template>

<script>
import Vue from 'vue'
import http from '@/http'
import { guid } from '@/utils'
import { mapActions, mapGetters } from 'vuex'
import { range, isObject, without, union, chunk, filter } from 'lodash'
import ModalEditor from '@/modules/editor/components/ModalEditor'
import CopyStructDialog from './CopyStructDialog'
import ExtractFloorsDialog from './ExtractFloorsDialog'

const DEFAULT_PLACEMENT_TYPE = 'apartment'
const DEFAULT_VIEWBOX = '0 0 720 540'
const GET_PLACEMENT_MODEL = () => ({
  id: null,
  layout_id: null,
  placement_type: DEFAULT_PLACEMENT_TYPE,
  path_placement: null,
  points: null,
  uuid: null,
})

// TODO: перенсти отсюда
// для дальнейшего переиспользования
const PLACEMENT_TYPES = {
  commercial: ['commercial'],
  house: ['apartment', 'storage', 'level'],
  parking: ['parking', 'storage'],
  townhouse: ['apartment', 'level'],
}

export default {
  name: 'Edit',
  props: ['id', 'objectId', 'sectionId', 'floorId'],

  components: {
    ModalEditor,
    CopyStructDialog,
    ExtractFloorsDialog,
    FloorSchemePreview: () => import('@/components/async/FloorSchemePreview'),
  },

  data: () => ({
    copyDialogIsOpen: false,
    ExtractFloorsDialogIsOpen: false,
    currentSectionForCopy: null,
    preview: null,
    tabs: {
      active: 0,
      list: require('@/enums/placement-types').placementTypes.list,
      getByObjectType: function (object) {
        // Показываем закладки только доступные для типа дома
        const alowedTabs = PLACEMENT_TYPES[object.object_type_id] || []
        return this.list.filter(({ id }) => alowedTabs.includes(id))
      },
    },
    avatar: null,
    selectedFloors: [],
    editorOpened: false,
    silent: false,
    item: {
      floor_numbers_array: [],
      floor_numbers: null,
      placements_count: 0,
      placements: {},
    },
    headers: [
      {
        text: 'idx',
        align: 'left',
        sortable: false,
        width: '0%',
      },
      {
        text: '№ пом.',
        align: 'left',
        sortable: false,
        width: '0%',
      },
      {
        text: 'Планировка',
        align: 'left',
        sortable: false,
        width: '40%',
      },
      {
        text: '',
        align: 'right',
        sortable: false,
        width: '10%',
      },
      {
        text: 'Обводка',
        align: 'right',
        sortable: false,
        width: '10%',
      },
      {
        text: '2-й уровень',
        align: 'center',
        sortable: false,
        width: '10%',
      },
      {
        text: '',
        align: 'right',
        sortable: false,
        width: '0%',
      },
    ],
    placements: [],
    maxPlacements: 999,
    expand: false,
    filter: {
      placement_type: DEFAULT_PLACEMENT_TYPE,
    },
  }),

  created() {
    if (!Object.keys(this.section).length) {
      this.fetchSections()
    }
  },

  async mounted() {
    await this.loadFloor()
  },

  methods: {
    async loadFloor() {
      if (this.floorId) {
        try {
          this.item = (await this.fetchSingle({ id: this.floorId })).data
        } catch (e) {
          this.$root.showSnack('Ошибка загрузки этажа')
        }
      }

      let { floor_numbers_array } = this.item
      if (!floor_numbers_array) return
      this.item.floor_numbers_array = floor_numbers_array.map((x) => +x)

      this.selectedFloors = union(
        this.checkedFloors,
        this.item.floor_numbers_array
      )

      this.setFilterByTabIndex(0)
    },

    copyFloorFromAllSetcion() {
      this.currentSectionForCopy = null
      this.copyDialogIsOpen=true
    },
    copyFloorInSetcion() {
      this.currentSectionForCopy = this.section.section_number
      this.copyDialogIsOpen=true
    },
    exctractFloors() {
      this.ExtractFloorsDialogIsOpen=true
    },
    applyPlacementStructCopy(struct) {
      const { placement_type } = this.filter
      const { placements, placements_count } = struct

      let index = 0
      const results = []
      while (index < placements_count) {
        if (placements[index] === undefined) {
          continue
        }
        const placement = {
          ...GET_PLACEMENT_MODEL(),
          placement_type,
          uuid: guid(),
          ...placements[index],
          id: placements[index].placement_number
        }
        // Нужны просто координаты
        let points = null
        if (placement.path_placement) {
          const path = placement.path_placement.split(/,/)
          points = chunk(path.map((x) => +x), 2)
        }
        // eof
        results.push({
          ...placement,
          points
        })
        index++
      }

      this.placements = results
      this.copyDialogIsOpen = false
    },

    goToNewFloor({new_floor}) {

      this.ExtractFloorsDialogIsOpen = false
      
      this.$router.push({
        name: 'Complexes.Objects.Sections.Floors.Edit',
        params: {
          id: this.id,
          objectId: this.objectId,
          sectionId: new_floor.section_id,
          floorId: new_floor.id
        }
      })
      this.$router.go(0);

      // eslint-disable-next-line no-console    
        // console.log(new_floor)
    },

    getLayoutImages(layoutId) {
      const layout = ((this.layoutsList || []).find(({ id }) => id === layoutId) || {})
      return [layout.render_view_url, layout.placement_sizing_url, layout.render_plan_url, layout.render_view_url, layout.placement_scheme_url]
    },

    getFirstNeedlePreviewImage(propsItem) {
      const images = this.getLayoutImages(propsItem.layout_id)
      return images.find(i => i !== null)
    },

    hasPreview(propsItem) {
      const images = this.getLayoutImages(propsItem.layout_id)
      return images.some(i => i !== null)
    },

    openPreview(propsItem) {
      const images = this.getLayoutImages(propsItem.layout_id)
      this.preview = images.find(image => image !== null) || null
    },

    closePreview() {
    },

    setFilterByTabIndex(index) {
      const tabs = this.tabs.getByObjectType(this.object)
      if (tabs[index]) {
        this.filter.placement_type = tabs[index].id
      }
    },

    async onSave() {
      let data = this.createFormData()

      try {
        if (this.floorId) {
          await this.update({ id: this.floorId, data })
        } else {
          await this.create({ data })
        }

        this.$root.showSnack('Этаж сохранен')
        this.back()
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    async fetchSections() {
      try {
        await this.fetchList({
          config: {
            params: {
              object_id: this.objectId,
            },
          },
        })
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки подъездов')
        this.back()
      }
    },

    back() {
      this.$router.push({
        name: 'Complexes.Objects.Sections',
        params: {
          id: this.id,
          objectId: this.objectId,
        },
      })
    },

    isFloorDisabled(index) {
      return this.checkedFloors.includes(index)
    },

    onRemoveScheme() {
      this.item.floor_scheme = null
    },

    createFormData() {
      let data = new FormData()

      // Объект для отправки Тимурчику
      let item = {
        ...this.item,
        section_id: this.sectionId,
        // Отберем ток нужные чекбоксы
        floor_numbers_array: without(
          this.selectedFloors,
          ...this.checkedFloors
        ),
        // Планировки
        placements: this.placements.reduce((acc, curr, index) => {
          let path = []

          if (null !== curr.points) {
            path = path.concat(...curr.points)
          }

          acc[index] = Object.assign(curr, {
            path_placement: path.join(','),
          })

          return acc
        }, {}),
        placements_count: this.placements.length,
      }

      const { editorViewBox } = this
      if (DEFAULT_VIEWBOX !== editorViewBox) {
        item.floor_viewbox = editorViewBox
        item.no_vb = 0
      } else {
        item.floor_viewbox = null
        item.no_vb = 1
      }

      Object.keys(item).forEach((key) => {
        data.append(
          key,
          isObject(item[key]) ? JSON.stringify(item[key]) : item[key]
        )
      })

      return data
    },

    onEditorUpdate(placements) {
      // обновляем только измененные плейсменты
      for (let placement of placements) {
        const index = this.placements.findIndex(
          ({ uuid }) => uuid === placement.uuid
        )
        if (index === -1) {
          continue
        }

        this.$set(this.placements, index, placement)
      }
    },

    onEditorRemove({ uuid }) {
      this.placements = this.placements.filter((x) => x.uuid !== uuid)
    },

    onEditorCreate({ points }) {
      // Тип помещения берем из фильтра
      let { placement_type } = this.filter
      // Попробуем найти квартиру, в которой нет обводки и тип соответствует
      // выбранной вкладке
      // добавим схему туда, либо обновим модель в коллекции
      let unusedIndex = this.placements.findIndex((x) => {
        return null === x.points && x.placement_type === placement_type
      })

      if (-1 === unusedIndex) {
        let placement = {
          ...GET_PLACEMENT_MODEL(),
          uuid: guid(),
          placement_type,
          points,
        }
        this.placements = this.placements.concat(placement)
      } else {
        Vue.set(this.placements, [unusedIndex], {
          ...this.placements[unusedIndex],
          placement_type,
          points,
        })
      }
      // TODO: это какое-то говно, передавать длину
      // и одноврменно список, неслыханное
      this.item.placements_count = this.placements.length
    },

    onChangePlacementsSort(placements) {
      this.placements = placements
    },

    createPlacementsOfType(type, count) {
      const placementsByType = this.placements.filter(
        (p) => p.placement_type === type
      )
      const totalPlacements = placementsByType.length
      // Нельзя создать меньше, чем уже есть
      if (count <= totalPlacements) {
        return
      }

      // Нужно создать сколько было - сколько создать
      // дабы получилось правильное кол-во
      let i = 0
      const createCount = count - totalPlacements

      while (i < createCount) {
        this.placements.push({
          ...GET_PLACEMENT_MODEL(),
          placement_type: type,
          uuid: guid(),
        })
        i++
      }
    },

    createInitialPlacements(count) {
      const { placement_type } = this.filter
      const serverCount = this.item.placements.length
      const createCount = count - serverCount

      if (createCount > 0) {
        const range = [...Array(createCount).keys()]

        for (const index of range) {
          if (this.placements[index]) {
            continue
          }

          this.placements.push({
            ...GET_PLACEMENT_MODEL(),
            placement_type,
            uuid: guid(),
          })
        }
      }
      // eslint-disable-next-line
//console.log('fuck!!!')
      // Это те херни, которые уже есть
      const serverPlacements = this.item.placements
      serverPlacements.forEach((placement) => {
        const inCollection = this.placements.find((p) => p.id === placement.id)
        if (!inCollection) {
          let points = null
          // prettier-ignore
          if (placement.path_placement) {
            const path = placement.path_placement.split(/,/)
            points = chunk(path.map((x) => +x), 2)
          }
          this.placements.push({
            ...placement,
            uuid: guid(),
            points,
          })
        }
      })
    },

    updatePlacementPoints(value, index) {
      let points = value
        ? chunk(
          value.split(/,/).map((x) => +x),
          2
        )
        : ''
      this.placements[index].points = points
    },

    async matchLayouts() {
      try {
        let params = {}
        params.floors = without(this.selectedFloors, ...this.checkedFloors)
        params.placements = this.placements
        params.section = this.section.section_number

        const result = (
          await http.post(
            'complexes/floors/' + this.floorId + '/matchlayouts',
            params
          )
        ).data

        if (result.length > 0) {
          this.placements = result
        }
      } catch (e) {
        this.$root.showSnack('Не удалось загрузить список клиентов')
      }
    },

    ...mapActions('objects/sections', {
      fetchList: 'fetchList',
      fetchSection: 'fetchSingle'
    }),
    ...mapActions('objects/floors', ['fetchSingle', 'update', 'create']),
  },

  computed: {
    countByType: {
      get() {
        const { placement_type } = this.filter
        return this.placements.reduce((acc, cur) => {
          if (cur.placement_type === placement_type) {
            acc = acc + 1
          }
          return acc
        }, 0)
      },
      set(count) {
        const type = this.filter.placement_type
        this.createPlacementsOfType(type, count)
      },
    },

    placementsByType() {
      const { placement_type } = this.filter
      return filter(this.placements, { placement_type })
    },

    section() {
      return this.sectionById(this.sectionId) || {}
    },

    object() {
      return this.objectById(this.objectId)
    },

    floors() {
      let { min_floor, max_floor, additional_floors } = this.section
      let floorsRange = range(min_floor, max_floor + 1)

      if (additional_floors) {
        let add = additional_floors.split(",").map(f => Number(f))
        floorsRange = floorsRange.concat(add)
      }


      return floorsRange
    },

    checkedFloors() {
      let { floors = [] } = this.section
      return floors
        .filter((x) => x.id != this.floorId)
        .reduce((acc, f) => {
          return acc.concat(f.floor_numbers_array.map((x) => +x))
        }, [])
    },

    ...mapGetters('objects/sections', {
      sectionById: 'byId',
      isSectionsLoading: 'isLoading',
      objectById: 'objectById',
    }),

    ...mapGetters('objects/floors', ['isLoading']),
    ...mapGetters('editor', { editorViewBox: 'computedViewBox' }),
    ...mapGetters('dictionary/layouts', { layoutsList: 'list' })
  },

  watch: {
    // переход на другой этаж: роутер переиспользует компонент,
    // поэтому данные загружаем заново
    async floorId() {
      if (!this.sectionById(this.sectionId)) {
        try {
          await this.fetchSection({ id: this.sectionId })
        } catch (e) {
          this.$root.showSnack('Ошибка загрузки подъезда')
        }
      }
      await this.loadFloor()
    },
    // устанавливает фильтр в зависимости
    // от выбранной вкладки
    'tabs.active'(index) {
      this.setFilterByTabIndex(index)
    },
    // первоначальное создание плейсментов
    'item.placements_count'(val) {
      if (val.placements_count > this.maxPlacements) {
        this.$validator.errors.add({
          field: 'placements_count',
          msg: `
            Макимальное кол-во квартир
            на этаже больше чем ${this.maxPlacements}
          `,
        })
      } else {
        this.$validator.errors.remove('placements_count')
        this.createInitialPlacements(val)
      }
    }
  }
}
</script>

<style scoped>
.floor-checker-btn {
  margin-right: 16px;
  display: inline-block;
}

.floors-picker {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.02);
}

.placements-list>>>tbody tr {
  border: 0 !important;
}

.placements-list>>>th,
.placements-list>>>td {
  padding: 0 6px !important;
}

.placement_path {
  font-size: 10px;
}

.inline-checkbox {
  position: relative;
  top: 12px;
}

.layout-view {
  display: grid;
  gap: 24px;
  grid-template-columns: 0.8fr 1fr;
}

.col-b {
  order: 2;
}

.col-a {
  order: 1;
}

.sticky-pane {
  position: sticky;
  top: 100px;
}

.preview-trigger {
  cursor: default;
  height: 65px;
  width: 65px;
  display: block;
}

.preview-trigger img {
  width: 100%;
  height: 100%;
  display: block;
}

.sticky-pane>>>.image-upload-preview {
  box-shadow: none;
}

.sticky-pane>>>.controls {
  justify-items: center;
  align-items: center;
  justify-content: center;
}

.sticky-pane>>>.spacer {
  display: none;
}

.hover-preview {
  overflow: hidden;
  aspect-ratio: 1;
  width: 25vw;
  background: white;
  position: relative;
}

.hover-preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.hover-tooltip {
  background: white;
  box-shadow: none;
  /* opacity: 1 !important; */
}

.highlight {
  color: #ff0000;
}
</style>
